import React from 'react';

class DashboardWidget11_2 extends React.Component {
  render() {
    const { title, subtitle, titleClass } = this.props;

    return (
      <div class="widget-11-2 card no-border card-condensed no-margin widget-loader-circle full-height d-flex flex-column">
        <div class="padding-25">
          <h2 class={'no-margin ' + titleClass}>{title}</h2>
          <p class="no-margin">{subtitle}</p>
        </div>
        <div class="auto-overflow widget-11-2-table">
          <table class="table table-condensed table-hover">
            <tbody>{this.props.children}</tbody>
          </table>
        </div>
      </div>
    );
  }
}
DashboardWidget11_2.defaultProps = {
  titleClass: '',
};

export default DashboardWidget11_2;
